<template>
  <global-dialog-card v-model="model" hide-actions :title="$t('employee')">
    <v-row align="center" v-if="user">
      <v-col cols="auto">
        <v-img
          height="128px"
          width="128px"
          :src="
            user.image_path
              ? conf.apiUrlBase + '/gallery/' + user.image_path
              : 'https://st3.depositphotos.com/13159112/17145/v/600/depositphotos_171453724-stock-illustration-default-avatar-profile-icon-grey.jpg'
          "
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col>
        <h2 class="black--text">
          {{ toLatin(user.name) + " " + toLatin(user.lastname) + " (" + user.id + ")" }}
        </h2>
        <h3>{{ user.email }}</h3>
        <h5>
          {{ $t("select_notifications") }}:
          {{ user.notifications ? translate(user.notifications) : $t("not_available") }}
        </h5>
        <h5 v-if="user.phone">{{ user.phone }}</h5>
        <h5 v-if="user.external_code">{{ user.external_code }}</h5>
        <h5 v-if="user.address">{{ toLatin(user.address) }}</h5>
        <h5 v-if="user.is_transferable">
          {{ $t("can_change_location") }}
        </h5>
      </v-col>
    </v-row>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import conf from "@/config";

export default {
  mixins: [hasModel],
  props: {
    user: {
      type: [Object, null, undefined],
    },
  },
  data: () => ({
    conf,
  }),
};
</script>
